export default __webpack_public_path__ + "static/media/StaticPage4.a6518a06.txt";